import { render, staticRenderFns } from "./EditWorkshopFormCpt.vue?vue&type=template&id=3718aa48&scoped=true&"
import script from "./EditWorkshopFormCpt.vue?vue&type=script&lang=ts&"
export * from "./EditWorkshopFormCpt.vue?vue&type=script&lang=ts&"
import style0 from "./EditWorkshopFormCpt.vue?vue&type=style&index=0&id=3718aa48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3718aa48",
  null
  
)

export default component.exports